export default __webpack_public_path__ + "static/media/filling_5.15074dc3.webp";